import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../reducers/literals.reducer';
import * as selectors from '../selectors/literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class LiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  literals$ = this.storeSelect(selectors.getLiteralsState);

  // OBSERVABLE'S VALUES
  get literals() {
    return this.storeSnapshot(this.literals$);
  }

  // GET TRANSLATION PROGRAMATICALLY
  getTranslatedLiteral(literal: string) {
    return this.storeSnapshot(this.literals$).literals[literal];
  }
}
